import moment from 'moment'
import type GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { validateExtractedCheckInOrCheckOutDate } from 'lib/search/searchUtils'
import type { ExperienceDateRange } from 'tripPlanner/utils/resolveSearchDefaults'

export function getValidExperienceDateRange(dateRange: ExperienceDateRange): ExperienceDateRange {
  const validatedCheckIn = validateExtractedCheckInOrCheckOutDate(dateRange.checkIn)
  if (!validatedCheckIn) return {}

  const checkIn = moment(validatedCheckIn, ISO_DATE_FORMAT, true)
  const validatedCheckOut = validateExtractedCheckInOrCheckOutDate(dateRange.checkOut)
  const checkOut = validatedCheckOut ? moment(validatedCheckOut, ISO_DATE_FORMAT, true) : checkIn

  return {
    checkIn: checkIn.format(ISO_DATE_FORMAT),
    checkOut: checkOut.isValid() && !checkOut.isBefore(checkIn, 'day') ?
        checkOut.format(ISO_DATE_FORMAT) :
        checkIn.format(ISO_DATE_FORMAT),
  }
}

export function getExperienceDateRangeFromSearchState(state: Pick<GlobalSearchState, 'checkinDate' | 'checkoutDate'>): ExperienceDateRange {
  return getValidExperienceDateRange({
    checkIn: state.checkinDate?.format(ISO_DATE_FORMAT),
    checkOut: state.checkoutDate?.format(ISO_DATE_FORMAT),
  })
}
